// extracted by mini-css-extract-plugin
export default {"productGallery":"UK-z","inQuickShop":"VK-z"};